import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app/App';
import { getFirebaseApp } from './firebase/app';
import './styles/global.css';

const root = document.getElementById('root');

if (!root) {
  throw new Error('Application root element was not found.');
}

getFirebaseApp();

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js', { updateViaCache: 'none' }).then((registration) => registration.update());
  });
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
